import compact from 'lodash/compact';

export type FeedbackBody = {
  screen?: string;
  name?: string;
  message: string;
  phone?: string;
  userID?: string;
  uploads?: number;
};

/**
 * Return crm link.
 */
export const getUserCRMLink = (userID?: string): string | undefined => {
  if (!userID) {
    return undefined;
  }
  return `${process.env.NEXT_PUBLIC_HOST}/admin/user/${userID}`;
};

/**
 * Add extra info to message.
 */
export const enrichMessage = async (body: FeedbackBody) => {
  const device = navigator.userAgent;
  return compact([
    body.message,
    `Screen: ${body.screen}`,
    getUserCRMLink(body.userID),
    `Device: ${device}`,
    `Name: ${body.name}`,
    (body.uploads || 0) > 0 ? `Screenshots(${body.uploads}):` : '',
    (body.uploads || 0) > 0 ? `${getUserCRMLink(body.userID)}/uploads` : '',
    body.phone && `Phone: ${body.phone}`,
  ]).join('\n');
};

export enum FeedbackMethod {
  Open = 'open',
  Submit = 'submit',
}

/**
 * send request to doorbell.
 */
export async function sendDoorbellRequest(method: FeedbackMethod, params?: FeedbackBody) {
  const body = method === FeedbackMethod.Open ? undefined : params;

  const endpoint = process.env.NEXT_PUBLIC_DOORBELL_END_POINT;
  const appID = process.env.NEXT_PUBLIC_DOORBELL_APP_ID;
  const key = process.env.NEXT_PUBLIC_DOORBELL_KEY;

  await fetch(`${endpoint}/${appID}/${method}?key=${key}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'User-Agent': navigator.userAgent,
    },
    body:
      body &&
      JSON.stringify({
        ...body,
        message: await enrichMessage(body),
      }),
  });
}
